import React, {useEffect, useState} from 'react';
import {placeholderFromType} from '../../components/common/loading';

import DynamicDestinationRefinementsDesktop from './components/DynamicDestinationRefinementsDesktop';
import DynamicDestinationRefinementsMobile from './components/DynamicDestinationRefinementsMobile';
import {fetchDestinationRefinementsData} from './constants';
import {buildRefinedSlpUrl} from '../../utils/urls';

import './style.less';

const DestinationRefinementsComponent = (props) => {
    const {
        lbsId,
        site,
        seoPath,
        isRefined,
        useSlpCanonical,
        mode = 'disabled',
        hasTouch,
    } = props;

    const [data, setData] = useState(null);

    useEffect(() => {
        fetchDestinationRefinementsData(props).then(setData).catch(setData);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!data) {
        return placeholderFromType(DestinationRefinementsComponent);
    }

    if (data instanceof Error) {
        throw data;
    }

    const {heading, subheading, cards = []} = data;

    if (!cards.length) {
        return null;
    }

    if (useSlpCanonical) {
        cards.forEach((card) => {
            const key = parseInt(card.filterId, 10);
            card.slpUrl = buildRefinedSlpUrl({seoPath, site, isRefined, key});

            if (!card.slpUrl.length) {
                card.noFollowHref = 'nofollow';
            }
        });
    }

    switch (mode) {
        case 'desktop-control':
            return (
                <DynamicDestinationRefinementsDesktop
                    lbsId={lbsId}
                    heading={heading}
                    subheading={subheading}
                    cards={cards}
                />
            );
        case 'touch-control':
            return (
                hasTouch && (
                    <DynamicDestinationRefinementsMobile
                        lbsId={lbsId}
                        heading={heading}
                        cards={cards}
                    />
                )
            );
        default:
            return null;
    }
};

export default DestinationRefinementsComponent;
